import { IRootState } from '@types';
import { Module } from 'vuex';

const store: Module<any, IRootState> = {
    state: {
        eventObservers: <any[]>[],
    },

    mutations: {
        eventsSubscribe(state, { events = {}, observable }) {
            // TODO: add resubscribe validation
            if (typeof observable == 'function' && !Array.isArray(events)) {
                throw 'If observable is a function, events have to be an Array';
            }
            if (typeof observable == 'object' && Array.isArray(events)) {
                throw 'If observable is an object, events have to be object with string pairs';
            }
            state.eventObservers.push({ events, observable });
        },

        eventsUnsubscribe(state, { observable }) {
            state.eventObservers = state.eventObservers.filter((o: any) => o.observable != observable);
        },

        eventsDispatch(state, { event, payload }) {
            // console.log('Events Dispatch', { event, payload });
            state.eventObservers.forEach((o: any) => {
                if (typeof o.observable == 'function' && o.events.includes(event)) {
                    return o.observable(payload);
                }

                if (Object.keys(o.events).includes(event)) {
                    // console.log('Events listener triggered', {
                    //     event,
                    //     component: o.observable.$options?.name,
                    //     uid: o.observable._uid,
                    // });
                    const method = o.events[event].method ?? o.events[event];
                    if (typeof o.observable.$emit == 'function') {
                        o.observable.$emit(`event:${method}`, payload);
                    }
                    if (typeof method == 'function') {
                        return method(payload);
                    }
                    if (typeof o.observable[method] == 'function') {
                        return o.observable[method](payload);
                    }
                }
            });
        },
    },
};

export default store;
